import React from 'react';
import { ReactComponent as DashboardIcon } from 'Images/icons/ic_nav_dashboard.svg';
import { ReactComponent as AddEmployee } from 'Images/icons/ic_nav_add_employee.svg';
import { ReactComponent as Employees } from 'Images/icons/ic_nav_all_employees.svg';
import { ReactComponent as Users } from 'Images/icons/ic_nav_not_registered.svg';
import { ReactComponent as Pending } from 'Images/icons/ic_nav_pending.svg';
import { ReactComponent as Completed } from 'Images/icons/ic_nav_completed.svg';

import { ReactComponent as DashboardIconActive } from 'Images/icons/ic_nav_dashboard_active.svg';
import { ReactComponent as AddEmployeeActive } from 'Images/icons/ic_nav_add_employee_active.svg';
import { ReactComponent as EmployeesActive } from 'Images/icons/ic_nav_all_employees_active.svg';
import { ReactComponent as UsersActive } from 'Images/icons/ic_nav_not_registered_active.svg';
import { ReactComponent as PendingActive } from 'Images/icons/ic_nav_pending_active.svg';
import { ReactComponent as CompletedActive } from 'Images/icons/ic_nav_completed_active.svg';

import Enum from 'es6-enum';

/**
 * Constants for App Shell
 */

// eslint-disable-next-line new-cap
export const NAVIGATION_TYPES = Enum('RAIL', 'TAB');

export const APP_ROUTES = {
  ROOT: '/',
  AUTH_ROOT: '/auth',
  AUTH_FORGOT_PASSWORD: '/auth/forgot_password',
  AUTH_SIGNIN: '/auth/signin',
  AUTH_SIGNIN_LANDING: '/auth/signin/landing',
  AUTH_SIGNED_OUT: '/auth/signout',
  DASHBOARD_PAGE: '/dashboard',
  EMPLOYEES_PAGE: '/employees',
  USERS_PAGE: '/users',
  PAGE_6: '/page/6',
};

export const APP_NAV_LINKS = [
  {
    navLabel: 'Dashboard',
    helpText: 'Dashboard',
    navIcon: <DashboardIcon />,
    navIconActive: <DashboardIconActive />,
    navRoute: APP_ROUTES.DASHBOARD_PAGE,
    navEnabled: true,
  },
  {
    navLabel: 'Employees',
    helpText: 'Employees',
    navIcon: <Employees />,
    navIconActive: <EmployeesActive />,
    navRoute: APP_ROUTES.EMPLOYEES_PAGE,
    navEnabled: true,
  },
  {
    navLabel: 'Page 3',
    helpText: 'Page 3',
    navIcon: <Completed />,
    navIconActive: <CompletedActive />,
    navRoute: APP_ROUTES.PAGE_3,
    navEnabled: false,
  },
  {
    navLabel: 'Page 4',
    helpText: 'Page 4',
    navIcon: <Pending />,
    navIconActive: <PendingActive />,
    navRoute: APP_ROUTES.EMPLOYEES_PAGE,
    navEnabled: false,
  },
  {
    navLabel: 'Users',
    helpText: 'Users',
    navIcon: <Users />,
    navIconActive: <UsersActive />,
    navRoute: APP_ROUTES.USERS_PAGE,
    navEnabled: true,
    restrictedToRole: process.env.AUTH_ROLE_CORP_HR_ADMIN,
  },
  {
    navLabel: 'Page 6',
    helpText: 'Page 6',
    navIcon: <AddEmployee />,
    navIconActive: <AddEmployeeActive />,
    navRoute: APP_ROUTES.PAGE_6,
    navEnabled: false,
  },
];
